module.exports = __webpack_public_path__ + "static/hair-from-back.0e9d9751.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hair-from-back.jpg
// module id = 466
// module chunks = 263791100135453